import { createReducer } from 'reduxsauce'
import { INITIAL_STATE } from './initialState'
import { AuthTypes } from './Actions'
import RequestState from 'Enums/RequestState'

export const operatorUserLoginLoading = (state) => {
  return {
    ...state,
    operatorUserLoading: true,
  }
}

export const onTwoFactorVerifySuccess = (
  state,
  { token, refreshToken, operatorUser },
) => {
  let operator = Object.assign({}, operatorUser.operator)
  operatorUser.operator = operator._id
  operator.hasOcpiIntegration = operatorUser.hasOcpiIntegration
  return {
    ...state,
    refreshToken: refreshToken,
    token: token,
    operator: operator,
    operatorUser: operatorUser,
    operatorUserLoading: false,
  }
}
export const onTwoFactorVerifyFail = (state) => {
  return {
    ...state,
    token: null,
    refreshToken: null,
    operatorUser: null,
    operatorUserLoading: false,
  }
}

export const onTwoFactorSetupVerifyFail = (state) => {
  return {
    ...state,
    otpauthUrl: null,
    manualKey: null,
    operatorUserLoading: false,
  }
}

export const onTwoFactorSetupVerifySuccess = (state) => {
  return {
    ...state,
    requires2FASetup: false,
    otpauthUrl: null,
    manualKey: null,
    operatorUserLoading: false,
    setupComplete: true,
  }
}

export const operatorUserLoginSuccess = (state, { loginData }) => {
  return {
    ...state,
    requires2FA: loginData.requires2FA,
    requires2FASetup: loginData.requires2FASetup,
    challengeId: loginData.challengeId,
    operatorUserLoading: false,
    otpauthUrl: loginData.otpauthUrl,
    manualKey: loginData.manualKey,
  }
}

export const operatorUserLoginFail = (state) => {
  return {
    ...state,
    requires2FA: false,
    requires2FASetup: false,
    challengeId: null,
    operatorUserLoading: false,
  }
}

export const operatorUserLoginResetClientState = (state) => {
  return {
    ...state,
    operatorUserLoading: false,
    requires2FA: false,
    requires2FASetup: false,
    challengeId: null,
    optauthUrl: null,
    manualKey: null,
    setupComplete: false,
  }
}

export const fetchOperatorUserLoading = (state) => {
  return {
    ...state,
    fetchOperatorUserRequestState: RequestState.LOADING,
  }
}

export const fetchOperatorUserSuccess = (state, { operatorUser }) => {
  return {
    ...state,
    operatorUser: operatorUser,
    fetchOperatorUserRequestState: RequestState.SUCCEEDED,
  }
}

export const fetchOperatorUserFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    operatorUser: null,
    fetchOperatorUserRequestState: requestState,
  }
}

export const setAuthToken = (state, { token }) => {
  return {
    ...state,
    token: token,
  }
}

export const resetPassLoading = (state) => {
  return {
    ...state,
    resetPasswordRequestState: RequestState.LOADING,
  }
}

export const resetPassSuccess = (state) => {
  return {
    ...state,
    resetPasswordRequestState: RequestState.SUCCEEDED,
  }
}

export const resetPassFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }

  return {
    ...state,
    resetPasswordRequestState: requestState,
  }
}

export const resetPassVerificationLoading = (state) => {
  return {
    ...state,
    resetPassVerificationRequestState: RequestState.LOADING,
  }
}

export const resetPassVerificationSuccess = (state, { emailID }) => {
  return {
    ...state,
    resetPassVerificationRequestState: RequestState.SUCCEEDED,
    resetPassEmailID: emailID,
  }
}

export const resetPassVerificationFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }

  return {
    ...state,
    resetPassVerificationRequestState: requestState,
  }
}

export const reducer = createReducer(INITIAL_STATE, {
  [AuthTypes.OPERATOR_USER_LOGIN_LOADING]: operatorUserLoginLoading,
  [AuthTypes.OPERATOR_USER_LOGIN_SUCCESS]: operatorUserLoginSuccess,
  [AuthTypes.OPERATOR_USER_LOGIN_FAIL]: operatorUserLoginFail,
  [AuthTypes.OPERATOR_USER_LOGIN_RESET_CLIENT_STATE]:
    operatorUserLoginResetClientState,
  [AuthTypes.FETCH_OPERATOR_USER_LOADING]: fetchOperatorUserLoading,
  [AuthTypes.FETCH_OPERATOR_USER_SUCCESS]: fetchOperatorUserSuccess,
  [AuthTypes.FETCH_OPERATOR_USER_FAIL]: fetchOperatorUserFail,
  [AuthTypes.SET_AUTH_TOKEN]: setAuthToken,
  [AuthTypes.RESET_PASS_LOADING]: resetPassLoading,
  [AuthTypes.RESET_PASS_FAIL]: resetPassFail,
  [AuthTypes.RESET_PASS_SUCCESS]: resetPassSuccess,
  [AuthTypes.RESET_PASS_VERIFICATION_LOADING]: resetPassVerificationLoading,
  [AuthTypes.RESET_PASS_VERIFICATION_SUCCESS]: resetPassVerificationSuccess,
  [AuthTypes.RESET_PASS_VERIFICATION_FAIL]: resetPassVerificationFail,
  [AuthTypes.ON_TWO_FACTOR_VERIFY_SUCCESS]: onTwoFactorVerifySuccess,
  [AuthTypes.ON_TWO_FACTOR_VERIFY_FAIL]: onTwoFactorVerifyFail,
  [AuthTypes.ON_TWO_FACTOR_SETUP_VERIFY_SUCCESS]: onTwoFactorSetupVerifySuccess,
  [AuthTypes.ON_TWO_FACTOR_SETUP_VERIFY_FAIL]: onTwoFactorSetupVerifyFail,
})
